module.exports = __webpack_public_path__ + "static/media/pinterest.e66fbccf.svg";